import { inject, Injectable } from '@angular/core';
import { GlobalFacadeService } from './global-facade.service';
import { ClientFacadeService } from './client-facade.service';
import { SmartphoneFacadeService } from './smartphone-facade.service';
import { AddressFacadeService } from './address-facade.service';
import { PaymentFacadeService } from './payment-facade.service';

@Injectable({
  providedIn: 'root'
})
export class StoreFacadeService {
  readonly #globalFacade = inject(GlobalFacadeService);
  readonly #clientFacade = inject(ClientFacadeService);
  readonly #smartphoneFacade = inject(SmartphoneFacadeService);
  readonly #addressFacade = inject(AddressFacadeService);
  readonly #paymentFacade = inject(PaymentFacadeService);


  /**
   * Elimina toda la información almacenada en sessionStorage y localStorage,
   * y restablece el estado de todos los "facades" controlados por `StoreFacade`.
   */
  resetApp(): void {
    sessionStorage.clear();
    localStorage.clear();
    this.resetAllStore();
  }
  /**
   * Restablece el estado de todos los "facades" controlados por
   * `StoreFacade` devolviéndolos a su estado inicial.
   *
   * Efectos secundarios: llama a `reset()` en `GlobalFacade`,
   * `ClientFacade`, `SmartphoneFacade`, `AddressFacade` y `PaymentFacade`.
   *
   * No recibe parámetros y no devuelve ningún valor.
   */
  resetAllStore(): void {
    this.#globalFacade.reset();
    this.#clientFacade.reset();
    this.#smartphoneFacade.reset();
    this.#addressFacade.reset();
    this.#paymentFacade.reset();
  }
}
